export default {
  all: { id: 'all' },
  sites: { id: 'sites' },
  users: { id: 'users' },
  userList: { id: 'user_list' },
  applications: { id: 'applications' },
  userGroupList: { id: 'user_group_list' },
  userGroupInfo: { id: 'user_group_info' },
  createUserGroup: { id: 'create_user_group' },
  editUserGroup: { id: 'edit_user_group' },
  deleteUserGroup: { id: 'delete_user_group' },
  deleteUserGroupMessage: { id: 'delete_user_group_message' },
  name: { id: 'name' },
  saveInfo: { id: 'save_info' },
  dateUpdated: { id: 'date_updated' },
}
